export default {
  IS_LOGGED: (state) => {
    return (state.token != null)
  },

  GET_TOKEN: (state) => {
    return state.token
  }
}
